import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuModalComponent } from '../modals/menu-modal/menu-modal.component';
import { ItemMenuModal, ItemMenuAgrupado } from '../models/item-menu-modal';
import { AutenticacaoService } from '../services/autenticacao.service';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PremissasService } from '../services/premissas.service';
import { FuncionarioService } from '../services/funcionario.service';
import { TelaDoFuncionario } from '../models/tela-do-funcionario';
import { PremissasSistema } from '../models/premissas-sistema';


// jquery
declare const $: any;

@Component({
  selector: "app-configuracoes",
  templateUrl: "./configuracoes.component.html",
  styleUrls: ["./configuracoes.component.scss"],
})
export class ConfiguracoesComponent implements OnInit {
  administrador = false;
  modulosAtivos: number[] = [];
  suporte = false;

  itensFinaisOrdenados: ItemMenuAgrupado[] = [];
  itens: ItemMenuModal[] = [
    {
      nome: "Gestão de Descontos",
      link: "gestao-de-descontos",
      permissao: { sistema: "gi", tela: "gestao-de-descontos", pai: "configuracoes" },
    },
    { nome: "Anexos", link: "anexos", permissao: { sistema: "gi", tela: "anexos", pai: "configuracoes" } },
    { nome: "Usuários", link: "usuarios", permissao: { sistema: "gi", tela: "usuarios", pai: "configuracoes" } },
    {
      nome: "Permissões de acesso",
      link: "permissoes-de-acesso",
      permissao: { sistema: "gi", tela: "permissoes-de-acesso", pai: "configuracoes" },
    },
    { nome: "Times", link: "times", permissao: { sistema: "gi", tela: "times", pai: "configuracoes" } },
    { nome: "Produtos", link: "produtos", permissao: { sistema: "gi", tela: "produtos", pai: "configuracoes" } },
    {
      nome: "Fornecedores de Estrutura",
      link: "fornecedores-estrutura",
      permissao: { sistema: "gi", tela: "fornecedores-estrutura", pai: "configuracoes" },
    },
    { nome: "Estruturas", link: "estruturas", permissao: { sistema: "gi", tela: "estruturas", pai: "configuracoes" } },
    {
      nome: "Gestão de Kits",
      link: "gestao-de-kits",
      permissao: { sistema: "gi", tela: "gestao-de-kits", pai: "configuracoes" },
    },
    {
      nome: "Perfil de Estrutura",
      link: "perfil-estrutura",
      permissao: { sistema: "gi", tela: "perfil-estrutura", pai: "configuracoes" },
    },
    {
      nome: "Combinação de Kits",
      link: "combinacao-de-kits",
      permissao: { sistema: "gi", tela: "combinacao-de-kits", pai: "configuracoes" },
    },
    {
      nome: "Tabela de Fretes",
      link: "tabela-de-fretes",
      permissao: { sistema: "gi", tela: "tabela-de-fretes", pai: "configuracoes" },
    },
    {
      nome: "Formas de Pagamento",
      link: "formas-de-pagamento",
      permissao: { sistema: "gi", tela: "formas-de-pagamento", pai: "configuracoes" },
    },
    {
      nome: "Condições de Pagamento",
      link: "condicoes-de-pagamento",
      permissao: { sistema: "gi", tela: "condicoes-de-pagamento", pai: "configuracoes" },
    },
    {
      nome: "Modelos de Email",
      link: "modelos-de-email",
      permissao: { sistema: "gi", tela: "modelos-de-email", pai: "configuracoes" },
    },
    { nome: "Promoções", link: "promocao", permissao: { sistema: "gi", tela: "promocao", pai: "configuracoes" } },
    {
      nome: "Matérias e Notícias",
      link: "materia",
      permissao: { sistema: "gi", tela: "materia", pai: "configuracoes" },
    },
    {
      nome: "Premissas da Empresa",
      link: "premissas",
      permissao: { sistema: "gi", tela: "premissas", pai: "configuracoes" },
    },
    {
      nome: "Loja de Integrações",
      link: "loja-integracoes",
      permissao: { sistema: "gi", tela: "loja-integracoes", pai: "configuracoes" },
    },
    {
      nome: "Loja de Produtos",
      link: "loja-produtos",
      permissao: { sistema: "gi", tela: "loja-produtos", pai: "configuracoes" },
    },
    {
      nome: "Fluxos de Trabalho",
      link: "workflows",
      permissao: { sistema: "gi", tela: "workflows", pai: "configuracoes" },
    },

    // Sub-menu: CRM
    {
      nome: "Funis",
      link: "configuracoes-crm/funis",
      permissao: { sistema: "gi", tela: "funis", pai: "configuracao-crm" },
    },
    {
      nome: "Tipos de Atividade",
      link: "configuracoes-crm/tipos-de-atividade",
      permissao: { sistema: "gi", tela: "tipos_de_atividade", pai: "configuracao-crm" },
    },
    {
      nome: "Tags",
      link: "configuracoes-crm/tags",
      permissao: { sistema: "gi", tela: "tagscrm", pai: "configuracao-crm" },
    },
    {
      nome: "Campos Personalizados",
      link: "configuracoes-crm/atributos",
      permissao: { sistema: "gi", tela: "atributos", pai: "configuracao-crm" },
    },

    // Sub-menu: Financiamento
    {
      nome: "Geral",
      link: "config-financiamento/geral",
      permissao: { sistema: "gi", tela: "geral", pai: "config-financiamento" },
    },
    {
      nome: "Quadros",
      link: "config-financiamento/funil",
      permissao: { sistema: "gi", tela: "funil-financiamento", pai: "config-financiamento" },
    },
    {
      nome: "Tipos de Atividade",
      link: "config-financiamento/tipo-atividade",
      permissao: { sistema: "gi", tela: "tipo-atividade-financiamento", pai: "config-financiamento" },
    },
    {
      nome: "Motivos de Encerramento",
      link: "config-financiamento/respostas",
      permissao: { sistema: "gi", tela: "resposta-financiamento", pai: "config-financiamento" },
    },
    {
      nome: "Motivos de Negativa",
      link: "config-financiamento/motivos-negativa",
      permissao: { sistema: "gi", tela: "motivo-negativa-financiamento", pai: "config-financiamento" },
    },
    {
      nome: "Formulários",
      link: "config-financiamento/proposta-formulario",
      permissao: { sistema: "gi", tela: "proposta-formulario", pai: "config-financiamento" },
    },

    // Sub-menu: Vendas
    {
      nome: "Quadros",
      link: "config-vendas/funil",
      permissao: { sistema: "gi", tela: "funil-orcamento", pai: "config-vendas" },
    },
    {
      nome: "Tipos de Atividade",
      link: "config-vendas/tipo-atividade",
      permissao: { sistema: "gi", tela: "tipo-atividade-orcamento", pai: "config-vendas" },
    },
    {
      nome: "Motivos de Encerramento",
      link: "config-vendas/respostas",
      permissao: { sistema: "gi", tela: "resposta-orcamento", pai: "config-vendas" },
    },

    // Sub-menu: Notificações
    {
      nome: "Geral",
      link: "config-notificacao/geral",
      permissao: { sistema: "gi", tela: "ntf-geral", pai: "config-notificacao" },
    },
    {
      nome: "Canais",
      link: "config-notificacao/canal",
      permissao: { sistema: "gi", tela: "ntf-canal", pai: "config-notificacao" },
    },
    {
      nome: "Eventos",
      link: "config-notificacao/evento",
      permissao: { sistema: "gi", tela: "ntf-evento", pai: "config-notificacao" },
    },
    {
      nome: "Modelos de E-mail",
      link: "config-notificacao/modelo-email",
      permissao: { sistema: "gi", tela: "ntf-modeloEmail", pai: "config-notificacao" },
    },

    // Sub-menu: Loja GI
    { nome: "Loja", link: "config-loja-gi/loja", permissao: { sistema: "gi", tela: "loja", pai: "config-loja-gi" } },
    {
      nome: "Menu",
      link: "config-loja-gi/menu",
      permissao: { sistema: "gi", tela: "menu-loja", pai: "config-loja-gi" },
    },

    // Sub-menu: Tabelas Adicionais
    { nome: "Etapas", link: "etapas", permissao: { sistema: "gi", tela: "etapas", pai: "configuracoes" } },
    {
      nome: "Modelos de Download",
      link: "modelos-de-download",
      permissao: { sistema: "gi", tela: "modelos-de-download", pai: "configuracoes" },
    },
    {
      nome: "Status de Orçamento",
      link: "orc-status",
      permissao: { sistema: "gi", tela: "orc-status", pai: "configuracoes" },
    },
    {
      nome: "Status de Contato",
      link: "contato-status",
      permissao: { sistema: "gi", tela: "contato-status", pai: "configuracoes" },
    },
    {
      nome: "Status de Repasse",
      link: "repasse-status",
      permissao: { sistema: "gi", tela: "repasse-status", pai: "configuracoes" },
    },
    {
      nome: "Motivos de Perda",
      link: "motivo-perda",
      permissao: { sistema: "gi", tela: "motivo-perda", pai: "configuracoes" },
    },
    { nome: "Tags", link: "tags", permissao: { sistema: "gi", tela: "tags", pai: "configuracoes" } },
    {
      nome: "Tabelas Classificação Personalizada",
      link: "tabela-personalizada",
      permissao: { sistema: "gi", tela: "tabela-personalizada", pai: "configuracoes" },
    },
    {
      nome: "Classificação Integrador",
      link: "classificacao-integrador",
      permissao: { sistema: "gi", tela: "classificacao-integrador", pai: "configuracoes" },
    },
    {
      nome: "Tipos de Ocorrência",
      link: "ocorrencia-tipo",
      permissao: { sistema: "gi", tela: "ocorrencia-tipo", pai: "configuracoes" },
    },
    { nome: "Setores", link: "setores", permissao: { sistema: "gi", tela: "setores", pai: "configuracoes" } },
    { nome: "Pendências", link: "pendencias", permissao: { sistema: "gi", tela: "tags", pai: "configuracoes" } },
    { nome: "Embalagem", link: "embalagem", permissao: { sistema: "gi", tela: "embalagem", pai: "configuracoes" } },
    {
      nome: "Grupo Motivo Perda",
      link: "grupo_motivo_perda",
      permissao: { sistema: "gi", tela: "grupo_motivo_perda", pai: "configuracoes" },
    },
    {
      nome: "Etapa da Ocorrência",
      link: "etapa-ocorrencia",
      permissao: { sistema: "gi", tela: "etapa-ocorrencia", pai: "configuracoes" },
    },
    {
      nome: "Etapa do Rastreio",
      link: "etapa-rastreio",
      permissao: { sistema: "gi", tela: "etapa-rastreio", pai: "configuracoes" },
    },
    {
      nome: "Precificação por UF",
      link: "precificacao-uf",
      permissao: { sistema: "gi", tela: "precificacao-uf", pai: "configuracoes" },
    },
    {
      nome: "Transferência Vendedor",
      link: "transferencia-vendedor",
      permissao: { sistema: "gi", tela: "transferencia-vendedor", pai: "configuracoes" },
    },
    {
      nome: "Tipos de Anexo",
      link: "geral/tipos-anexo",
      permissao: { sistema: "gi", tela: "tipo-anexo", pai: "configuracoes" },
    },
    {
      nome: "Termos de Aceite",
      link: "geral/termos-aceite",
      permissao: { sistema: "gi", tela: "termo-aceite", pai: "configuracoes" },
    },
    {
      nome: "KPI's",
      link: "geral/kpis",
      permissao: { sistema: "gi", tela: "kpi", pai: "configuracoes" },
    },
    {
      nome: "Objetivos",
      link: "geral/objetivos",
      permissao: { sistema: "gi", tela: "objetivo", pai: "configuracoes" },
    },
    {
      nome: "Análise de Crédito",
      link: "geral/analise-credito",
      permissao: { sistema: "gi", tela: "analise-credito", pai: "configuracoes" },
    },
    {
      nome: "Categoria",
      link: "categoria",
      permissao: { sistema: "gi", tela: "categoria", pai: "configuracoes" }
    },
    {
      nome: "Feriado",
      link: "feriado",
      permissao: { sistema: "gi", tela: "feriado", pai: "configuracoes" }
    },
  ];

  itensAtivos: ItemMenuModal[] = [];
  telasDoFuncionario: TelaDoFuncionario[] = [];

  itensCRM: ItemMenuModal[] = [];
  showCRM = false;
  usarCRM = false;

  itensFinanciamento: ItemMenuModal[] = [];
  showFinanciamento = false;

  itensOrcamento: ItemMenuModal[] = [];
  showOrcamento = false;

  itensNotificacao: ItemMenuModal[] = [];
  showNotificacao = false;

  itensTabelasAdicionais: ItemMenuModal[] = [];
  showTabelasAdicionais = false;

  itensLojaGI: ItemMenuModal[] = [];
  showLojaGI = false;

  usarLojaProdutos = false;

  premissasSistema: PremissasSistema = new PremissasSistema();

  constructor(
    private globalService: GlobalService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private autenticacaoService: AutenticacaoService,
    private premissasService: PremissasService,
    private funcionarioService: FuncionarioService
  ) { }

  async ngOnInit() {
    await this.buscarPremissasSistema();
    await this.buscarModulosAtivos();
    await this.buscarPremissaUsarLojaProdutos();
    this.administrador = await this.globalService.administrador();
    this.suporte = await this.globalService.suporte();

    this.carregandoService.esconde("buscaTelas");
    this.funcionarioService.consultarTelasDoFuncionario().subscribe(
      (telas: any) => {
        this.telasDoFuncionario = telas;

        const itensConfigCrm = [
          "configuracoes-crm/funis",
          "configuracoes-crm/tipos-de-atividade",
          "configuracoes-crm/tags",
          "configuracoes-crm/atributos",
        ];

        const itensConfigFinanciamento = [
          "config-financiamento/geral",
          "config-financiamento/funil",
          "config-financiamento/tipo-atividade",
          "config-financiamento/respostas",
          "config-financiamento/motivos-negativa",
          "config-financiamento/proposta-formulario",
        ];

        const itensConfigOrcamento = ["config-vendas/funil", "config-vendas/tipo-atividade", "config-vendas/respostas"];

        const itensConfigNotificacao = [
          "config-notificacao/geral",
          "config-notificacao/canal",
          "config-notificacao/evento",
          "config-notificacao/modelo-email",
        ];

        const itensConfigLojaGi = ["config-loja-gi/loja", "config-loja-gi/menu"];

        const itensTabelasAdicionais = [
          "etapas",
          "modelos-de-download",
          "orc-status",
          "contato-status",
          "repasse-status",
          "motivo-perda",
          "tags",
          "tabela-personalizada",
          "servico-entrega",
          "seguro",
          "classificacao-integrador",
          "ocorrencia-tipo",
          "setores",
          "pendencias",
          "embalagem",
          "grupo_motivo_perda",
          "etapa-ocorrencia",
          "etapa-rastreio",
          "geral/tipos-anexo",
          "geral/objetivos",
          "geral/kpis",
          "geral/analise-credito",
          "geral/termos-aceite",
          "categoria",
          "feriado",
        ];

        const itensPermitidos = this.itens.filter((p) =>
          this.telasDoFuncionario.some(
            (t) => t.pai === p.permissao.pai && t.sistema === p.permissao.sistema && t.tela === p.permissao.tela
          )
        );

        this.itensAtivos = itensPermitidos.filter(
          (p) =>
            !itensConfigCrm.includes(p.link) &&
            !itensConfigFinanciamento.includes(p.link) &&
            !itensTabelasAdicionais.includes(p.link) &&
            !itensConfigOrcamento.includes(p.link) &&
            !itensConfigNotificacao.includes(p.link) &&
            !itensConfigLojaGi.includes(p.link)
        );

        this.itensCRM = itensPermitidos.filter((p) => itensConfigCrm.includes(p.link));
        this.itensFinanciamento = itensPermitidos.filter((p) => itensConfigFinanciamento.includes(p.link));
        this.itensTabelasAdicionais = itensPermitidos.filter((p) => itensTabelasAdicionais.includes(p.link));
        this.itensOrcamento = itensPermitidos.filter((p) => itensConfigOrcamento.includes(p.link));
        this.itensNotificacao = itensPermitidos.filter((p) => itensConfigNotificacao.includes(p.link));
        this.itensLojaGI = itensPermitidos.filter((p) => itensConfigLojaGi.includes(p.link));

        if (!this.usarLojaProdutos) {
          if (this.itensAtivos.some((p) => p.nome === "Loja de Produtos")) {
            this.itensAtivos.splice(
              this.itensAtivos.indexOf(this.itensAtivos.find((p) => p.nome === "Loja de Produtos")),
              1
            );
          }
        }

        if (!this.possuiModulo(15)) {
          if (this.itensAtivos.some((p) => p.nome === "Financiamento")) {
            this.itensAtivos.splice(
              this.itensAtivos.indexOf(this.itensAtivos.find((p) => p.nome === "Financiamento")),
              1
            );
          }
        }

        if (!this.possuiModulo(16)) {
          if (this.itensAtivos.some((p) => p.nome === "Vendas")) {
            this.itensAtivos.splice(this.itensAtivos.indexOf(this.itensAtivos.find((p) => p.nome === "Vendas")), 1);
          }
        }

        if (this.itensAtivos.some((p) => p.nome === "Loja GI")) {
          this.itensAtivos.splice(this.itensAtivos.indexOf(this.itensAtivos.find((p) => p.nome === "Loja GI")), 1);
        }

        if (!this.premissasSistema.usarPrecificacaoPorUF) {
          if (this.itensAtivos.some((p) => p.nome === "Precificação por UF")) {
            this.itensAtivos.splice(
              this.itensAtivos.indexOf(this.itensAtivos.find((p) => p.nome === "Precificação por UF")),
              1
            );
          }
        }

        let itensParaOrdenar: ItemMenuAgrupado[] = [];

        itensParaOrdenar = itensParaOrdenar.concat(
          this.itensAtivos.map((item) => ({
            nome: item.nome,
            tipo: "link",
            link: item.link,
            permissao: item.permissao,
          }))
        );

        this.buscarPremissaUsarCRM();

        // Adicionar Grupos (Submenus)
        if (this.usarCRM && this.itensCRM.length) {
          itensParaOrdenar.push({
            nome: "CRM",
            tipo: "grupo",
            itensInternos: this.ordenarItens(this.itensCRM),
            idHtml: "collapseCRM",
            show: false,
          });
        }

        if (this.itensFinanciamento.length) {
          itensParaOrdenar.push({
            nome: "Financiamento",
            tipo: "grupo",
            itensInternos: this.ordenarItens(this.itensFinanciamento),
            idHtml: "collapseFinanciamento",
            show: false,
          });
        }

        if (this.itensOrcamento.length) {
          itensParaOrdenar.push({
            nome: "Vendas",
            tipo: "grupo",
            itensInternos: this.ordenarItens(this.itensOrcamento),
            idHtml: "collapseOrcamento",
            show: false,
          });
        }

        if (this.suporte && this.itensNotificacao.length) {
          itensParaOrdenar.push({
            nome: "Notificações",
            tipo: "grupo",
            itensInternos: this.ordenarItens(this.itensNotificacao),
            idHtml: "collapseNotificacao",
            show: false,
          });
        }

        if (this.itensTabelasAdicionais.length) {
          itensParaOrdenar.push({
            nome: "Tabelas Adicionais",
            tipo: "grupo",
            itensInternos: this.ordenarItens(this.itensTabelasAdicionais),
            idHtml: "collapseTabelasAdicionais",
            show: false,
          });
        }

        if (this.itensLojaGI.length) {
          itensParaOrdenar.push({
            nome: "Loja GI",
            tipo: "grupo",
            itensInternos: this.ordenarItens(this.itensLojaGI),
            idHtml: "collapseLojaGI",
            show: false,
          });
        }

        this.itensFinaisOrdenados = itensParaOrdenar.sort((a, b) =>
          a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" })
        );

        this.buscarMultiFornecedores();
        this.buscarPremissaCentroDeDistribuicao();
        this.buscarAtivarVoucher();
        this.buscarUsarDescarga();
        this.buscarUsarServicoEntrega();
        this.buscarUsarSeguro();

        this.itensAtivos.sort((a, b) => a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" }));
        this.itensCRM.sort((a, b) => a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" }));
        this.itensFinanciamento.sort((a, b) => a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" }));
        this.itensOrcamento.sort((a, b) => a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" }));
        this.itensNotificacao.sort((a, b) => a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" }));
        this.itensTabelasAdicionais.sort((a, b) => a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" }));
        this.itensLojaGI.sort((a, b) => a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" }));

        this.carregandoService.esconde("buscaTelas");
      },
      (erro) => {
        this.carregandoService.esconde("buscaTelas");
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra("buscarPremissasSistema");
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("buscarPremissasSistema");
    }
  }

  private ordenarItens(itens: ItemMenuModal[]) {
    return itens.sort((a, b) => a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" }));
  }

  buscarUsarServicoEntrega() {
    this.carregandoService.mostra("buscarUsarServicoEntrega");

    this.premissasService.consultarUsarServicoEntrega().subscribe(
      (dados) => {
        if (
          dados.valor &&
          this.telasDoFuncionario.some((p) => p.tela === "servico-entrega" && p.pai === "configuracoes")
        ) {
          // this.itensTabelasAdicionais.push({ nome: 'Serviço de Entrega', link: 'servico-entrega', permissao: { sistema: 'gi', tela: 'servico-entrega', pai: 'configuracoes' } });

          const novoSubItem: ItemMenuModal = {
            nome: "Serviço de Entrega",
            link: "servico-entrega",
            permissao: { sistema: "gi", tela: "servico-entrega", pai: "configuracoes" },
          };
          const grupoTabelas = this.itensFinaisOrdenados.find(
            (i) => i.nome === "Tabelas Adicionais" && i.tipo === "grupo"
          );

          if (grupoTabelas) {
            grupoTabelas.itensInternos.push(novoSubItem);
            this.ordenarItens(grupoTabelas.itensInternos);
          }
        }

        this.carregandoService.esconde("buscarUsarServicoEntrega");
      },
      (err) => {
        this.carregandoService.esconde("buscarUsarServicoEntrega");
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarUsarSeguro() {
    this.carregandoService.mostra("buscarUsarSeguro");

    this.premissasService.consultarUsarSeguro().subscribe(
      (dados) => {
        if (dados.valor && this.telasDoFuncionario.some((p) => p.tela === "seguro" && p.pai === "configuracoes")) {
          // this.itensTabelasAdicionais.push({ nome: 'Seguro', link: 'seguro', permissao: { sistema: 'gi', tela: 'seguro', pai: 'configuracoes' } });

          const novoSubItem: ItemMenuModal = {
            nome: "Seguro",
            link: "seguro",
            permissao: { sistema: "gi", tela: "seguro", pai: "configuracoes" },
          };
          const grupoTabelas = this.itensFinaisOrdenados.find(
            (i) => i.nome === "Tabelas Adicionais" && i.tipo === "grupo"
          );

          if (grupoTabelas) {
            grupoTabelas.itensInternos.push(novoSubItem);
            this.ordenarItens(grupoTabelas.itensInternos);
          }
        }

        this.carregandoService.esconde("buscarUsarSeguro");
      },
      (err) => {
        this.carregandoService.esconde("buscarUsarSeguro");
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarUsarDescarga() {
    this.carregandoService.mostra("buscarUsarDescarga");

    this.premissasService.consultarUsarDescarga().subscribe(
      (dados) => {
        if (dados.valor && this.telasDoFuncionario.some((p) => p.tela === "descarga" && p.pai === "configuracoes")) {
          const novoItem: ItemMenuAgrupado = {
            nome: "Descarga",
            tipo: "link",
            link: "descarga",
            permissao: { sistema: "gi", tela: "descarga", pai: "configuracoes" },
          };
          this.itensFinaisOrdenados.push(novoItem);
          this.itensFinaisOrdenados.sort((a, b) => a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" }));
        }

        this.carregandoService.esconde("buscarUsarDescarga");
      },
      (err) => {
        this.carregandoService.esconde("buscarUsarDescarga");
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarPremissaUsarCRM() {
    this.carregandoService.mostra("buscarPremissaUsarCRM");
    this.premissasService.consultarUsarCRM().subscribe(
      (dados) => {
        this.usarCRM = dados.valor;

        this.carregandoService.esconde("buscarPremissaUsarCRM");
      },
      (erro) => {
        this.carregandoService.esconde("buscarPremissaUsarCRM");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra("buscarPremissaCentroDeDistribuicao");
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      (dados) => {
        if (
          dados.valor &&
          this.telasDoFuncionario.some((p) => p.tela === "centros-de-distribuicao" && p.pai === "configuracoes")
        ) {
          const novoItem: ItemMenuAgrupado = {
            nome: "Centros de Distribuição",
            tipo: "link",
            link: "centros-de-distribuicao",
            permissao: { sistema: "gi", tela: "centros-de-distribuicao", pai: "configuracoes" },
          };
          this.itensFinaisOrdenados.push(novoItem);
          this.itensFinaisOrdenados.sort((a, b) => a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" }));

          // this.itensAtivos.push({ nome: 'Centros de Distribuição', link: 'centros-de-distribuicao', permissao: { sistema: 'gi', tela: 'centros-de-distribuicao', pai: 'configuracoes' } });
          // this.itensAtivos.sort((a, b) => a.nome.localeCompare(b.nome, 'pt', { sensitivity: 'base' }));
        }

        this.carregandoService.esconde("buscarPremissaCentroDeDistribuicao");
      },
      (erro) => {
        this.carregandoService.esconde("buscarPremissaCentroDeDistribuicao");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMultiFornecedores() {
    this.carregandoService.mostra("buscarMultiFornecedores");
    this.premissasService.consultarMultiFornecedores().subscribe(
      (dados) => {
        if (
          dados.valor &&
          this.telasDoFuncionario.some((p) => p.tela === "fornecedores" && p.pai === "configuracoes")
        ) {
          const novoItem: ItemMenuAgrupado = {
            nome: "Fornecedores",
            tipo: "link",
            link: "fornecedores",
            permissao: { sistema: "gi", tela: "fornecedores", pai: "configuracoes" },
          };
          this.itensFinaisOrdenados.push(novoItem);
          this.itensFinaisOrdenados.sort((a, b) => a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" }));

          // this.itensAtivos.push({ nome: 'Fornecedores', link: 'fornecedores', permissao: { sistema: 'gi', tela: 'fornecedores', pai: 'configuracoes' } });
          // this.itensAtivos.sort((a, b) => a.nome.localeCompare(b.nome, 'pt', { sensitivity: 'base' }));
        }

        this.carregandoService.esconde("buscarMultiFornecedores");
      },
      (erro) => {
        this.carregandoService.esconde("buscarMultiFornecedores");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarAtivarVoucher() {
    this.carregandoService.mostra("buscarAtivarVoucher");

    this.premissasService.consultarAtivarVoucher().subscribe(
      (dados) => {
        if (dados.valor && this.telasDoFuncionario.some((p) => p.tela === "vouchers" && p.pai === "configuracoes")) {
          const novoItem: ItemMenuAgrupado = {
            nome: "Voucher Geral",
            tipo: "link",
            link: "vouchers",
            permissao: { sistema: "gi", tela: "vouchers", pai: "configuracoes" },
          };
          this.itensFinaisOrdenados.push(novoItem);
          this.itensFinaisOrdenados.sort((a, b) => a.nome.localeCompare(b.nome, "pt", { sensitivity: "base" }));

          // this.itensAtivos.push({ nome: 'Voucher Geral', link: 'vouchers', permissao: { sistema: 'gi', tela: 'vouchers', pai: 'configuracoes' }});
          // this.itensAtivos.sort((a, b) => a.nome.localeCompare(b.nome, 'pt', { sensitivity: 'base' }));
        }

        this.carregandoService.esconde("buscarAtivarVoucher");
      },
      (err) => {
        this.carregandoService.esconde("buscarAtivarVoucher");
        this.notificacaoService.erro(err);
      }
    );
  }

  toggleGrupo(item: ItemMenuAgrupado) {
    item.show = !item.show;

    if (item.idHtml) {
      if (item.show) {
        $(`#${item.idHtml}`).addClass("show");
      } else {
        $(`#${item.idHtml}`).removeClass("show");
      }
    }
  }

  abrirMenu() {
    const largura = Number($("body").width());

    const dialogRef = this.dialog.open(MenuModalComponent, {
      width: largura > 730 ? "700px" : $("body").width().toString() + "px",
      data: { itens: this.itens },
      panelClass: "modal-card",
    });

    dialogRef.afterClosed().subscribe((result: ItemMenuModal) => {
      if (result) {
        this.router.navigate([result.link], { relativeTo: this.route });
      }
    });
  }

  toggleTabelasAdicionais() {
    this.showTabelasAdicionais = !this.showTabelasAdicionais;

    if (this.showTabelasAdicionais) {
      $("#collapseTabelasAdicionais").addClass("show");
    } else {
      $("#collapseTabelasAdicionais").removeClass("show");
    }
  }

  toggleCRM() {
    this.showCRM = !this.showCRM;

    if (this.showCRM) {
      $("#collapseCRM").addClass("show");
    } else {
      $("#collapseCRM").removeClass("show");
    }
  }

  toggleFinanciamento() {
    this.showFinanciamento = !this.showFinanciamento;

    if (this.showFinanciamento) {
      $("#collapseFinanciamento").addClass("show");
    } else {
      $("#collapseFinanciamento").removeClass("show");
    }
  }

  toggleOrcamento() {
    this.showOrcamento = !this.showOrcamento;

    if (this.showOrcamento) {
      $("#collapseOrcamento").addClass("show");
    } else {
      $("#collapseOrcamento").removeClass("show");
    }
  }

  toggleNotificacao() {
    this.showNotificacao = !this.showNotificacao;

    if (this.showNotificacao) {
      $("#collapseNotificacao").addClass("show");
    } else {
      $("#collapseNotificacao").removeClass("show");
    }
  }

  buscarPremissaUsarLojaProdutos() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra("buscarPremissaUsarLojaProdutos");

      this.premissasService.consultarUsarLojaProdutos().subscribe(
        (p) => {
          this.usarLojaProdutos = p.valor;
          this.carregandoService.esconde("buscarPremissaUsarLojaProdutos");
          resolve();
        },
        (erro) => {
          this.carregandoService.esconde("buscarPremissaUsarLojaProdutos");
          this.notificacaoService.erro(erro);
          reject(erro);
        }
      );
    });
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some((p) => p === modulo);
  }

  async buscarModulosAtivos() {
    try {
      this.carregandoService.mostra("buscarModulosAtivos");

      this.modulosAtivos = await this.premissasService.consultarModulosAtivos().toPromise();

      this.carregandoService.esconde("buscarModulosAtivos");
    } catch (erro) {
      this.carregandoService.esconde("buscarModulosAtivos");
      this.notificacaoService.erro(erro);
    }
  }
}
